/**
 * URLs et contacts centralisés — site vitrine React (eventsbilletterie.com).
 * Surcharge possible via .env (REACT_APP_*), puis redémarrer `npm start`.
 */

export const SITE_ORIGIN = (process.env.REACT_APP_SITE_ORIGIN || 'https://eventsbilletterie.com').replace(/\/$/, '');

export const API_BASE_URL = (
    process.env.REACT_APP_API_BASE_URL || 'https://backoffice.eventsbilletterie.com/api'
).replace(/\/$/, '');

export const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL || 'contact@eventsbilletterie.com';
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || 'support@eventsbilletterie.com';
export const SUPPORT_ORGANIZERS_EMAIL =
    process.env.REACT_APP_SUPPORT_ORGANIZERS_EMAIL || 'support.organizers@eventsbilletterie.com';

/** Chemin absolu sur le site vitrine (ex. `/events`, `/go`). */
export function siteUrl(path = '') {
    if (!path) return SITE_ORIGIN;
    return `${SITE_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
}

/** Image statique servie par le site React (public/assets). */
export function siteAssetUrl(relativePath) {
    const p = String(relativePath || '').replace(/^\/+/, '');
    return `${SITE_ORIGIN}/assets/${p}`;
}

/** Endpoint API backoffice (chemin relatif à /api). */
export function apiUrl(relativePath) {
    const p = String(relativePath || '').replace(/^\/+/, '');
    return `${API_BASE_URL}/${p}`;
}
